var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"copyrights"},[_c('div',{staticClass:"container"},[_c('p',{staticStyle:{"color":"white","font-family":"'Times New Roman', Times, serif"}},[_vm._v("\n            © 2020 - "+_vm._s(_vm.year)+" Aslan Yazılım Tüm Hakları Saklıdır\n          ")]),_vm._v(" "),_c('div',{staticClass:"credits"})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26e37cf5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/default/Footer.vue
// module id = 100
// module chunks = 0